/* eslint-disable no-redeclare */
import { z } from 'zod';

export const PageViewDestination = z.string().min(1);
export type PageViewDestination = z.infer<typeof PageViewDestination>;

export const PageType = z.enum([
  'DEFAULT_TYP',
  'BRANDED_TYP',
  'QUOTES',
  'QUOTE_DETAILS',
  'FAS',
  'FEEDBACK',
]);
export type PageType = z.infer<typeof PageType>;
